import {useState, useRef} from 'react';
import { AppShell, Burger } from '@mantine/core';
import { Select, Button } from '@mantine/core';
import { Tabs, Text, Group,  } from '@mantine/core';
import { IconPhoto, IconMessageCircle, IconUpload, IconX, IconSettings } from '@tabler/icons-react';

import { Dropzone, MIME_TYPES } from '@mantine/dropzone';

import convert from 'xml-js';

import useStore from './store';
import ErrorMessages from './entities/ErrorMessages';


let jsonMision=[];

export const Layout=(props)=> {
  const [opened, setOpened] = useState(false);
  const [location, setLocation] = useState("");
  const [armState, setArmState] = useState("");

  // REMOVED: Redundant local state - now using entity objects directly
  // These local states duplicated the entity state unnecessarily
  // Now reading directly from robot, almacen, ikasmak, medicion, notificationSystem entities

  const [selectedTab, setSelectedTab] = useState("BehaviorTree");
  

  const [executingMission, setExecutingMission] = useState(false);
  const [xmlLoaded, setXMLLoaded] = useState(false);

 const setOpenDrawer=useStore((state)=>state.setOpenDrawer);
 // const openDrawer=useStore((state)=>state.openDrawer); // Unused but kept for future use
 // Use refs for synchronous state tracking
 const openDrawerRef = useRef(false);


 const setOpenMachineDoor=useStore((state)=>state.setOpenMachineDoor);
  // const openMachineDoor=useStore((state)=>state.openMachineDoor); // Unused but kept for future use
  // Use refs for synchronous state tracking
  const openMachineDoorRef = useRef(false);

 const systemLog=useStore((state)=>state.systemLog);
 const addToSystemLog=useStore((state)=>state.addToSystemLog);
 const clearSystemLog=useStore((state)=>state.clearSystemLog);

  const errorLog=useStore((state)=>state.errorLog);
 const addToErrorLog=useStore((state)=>state.addToErrorLog);
 const resetErrorSession=useStore((state)=>state.resetErrorSession);
 // const clearErrorLog=useStore((state)=>state.clearErrorLog); // Unused but kept for future use

  const setRobotLocation=useStore((state)=>state.setRobotLocation);
  // const robotLocation = useStore((state)=>state.robotLocation); // Unused but kept for future use
  const setRobotArmState=useStore((state)=>state.setRobotArmState);

  // Access entity objects from store for real-time state tracking
  const robot = useStore((state) => state.robot);
  const almacen = useStore((state) => state.almacen);
  const ikasmak = useStore((state) => state.ikasmak);
  const medicion = useStore((state) => state.medicion);
  const notificationSystem = useStore((state) => state.notifications);
  const syncUIState = useStore((state) => state.syncUIState);

  // MOVE ROBOT-----------------
        const moveRobot=(final_destination, end_callback)=>{
            // Get fresh location from robot entity
            const { robot } = useStore.getState();
            const currentLocation = robot.getLocation();
            const destination = final_destination;

            // Check if already at destination
            if (currentLocation.toLowerCase() === destination.toLowerCase()) {
                const errorMsg = `Robot ya está en ${destination}, no se requiere movimiento!!`;
                console.log(`[moveRobot] ${errorMsg}`);
                addToErrorLog(errorMsg);

                // Still call callback to continue execution
                if (end_callback) {
                    end_callback();
                }
                return;
            }

            console.log(" * Moving robot to:  " + final_destination);
            addToSystemLog(" * Moving robot to:  " + final_destination);
            const origen = currentLocation;

            const movement_sequences={
                "almacen": {
                            "almacen": ["almacen"],
                            "ikasmak": ["frente_almacen","frente_maquina","maquina"],
                            "cargador": ["frente_almacen","cargador"],
                            "metrologia": ["frente_almacen", "frente_metrologia", "metrologia"]
                        },
                "ikasmak": {
                    "almacen": ["frente_maquina","frente_almacen","almacen"],
                    "ikasmak": ["maquina"],
                    "cargador": ["frente_maquina","frente_almacen","cargador"],
                    "metrologia": ["frente_almacen", "frente_metrologia", "metrologia"]
                },
                "cargador": {
                    "almacen": ["frente_almacen","almacen"],
                    "ikasmak": ["frente_maquina", "maquina"],
                    "cargador": ["cargador"],
                    "metrologia": ["frente_almacen", "frente_metrologia", "metrologia"]
                },
                "metrologia": {
                    "almacen": ["frente_metrologia", "frente_almacen","almacen"],
                    "ikasmak": ["frente_metrologia", "frente_maquina", "maquina"],
                    "cargador": ["frente_metrologia", "cargador"],
                    "metrologia": ["frente_almacen", "frente_metrologia", "metrologia"]
                },                
            }


            const moveToDestination=(origen, destination)=>{
            const moveRobot=(steps)=>{
                const this_step=steps.shift();
                if(this_step){
                    setRobotLocation(this_step);
                    setTimeout(()=>{
                        moveRobot(steps);
                    }, 1000);
                } else {
                    console.log("     · Arrived to destination");

                    // Use entity object
                    setRobotLocation(destination);
                    syncUIState();

                    if(end_callback ){
                        end_callback();
                    }

                }
            }

            const normalizedDestination = destination.toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace("medicion", "metrologia");

            const normalizedOrigin = origen.toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace("medicion", "metrologia");

            moveRobot(movement_sequences[normalizedOrigin][normalizedDestination]);
            };

            moveToDestination(origen.toLowerCase(), destination.toLowerCase());
        }  
  // \MOVE

  // PICK 
    const pick=(end_callback)=>{
        const arm_sequence=["reposo","extendido0","extendido1","extendido2","extendido3", "extendido4", "extendido5", "extendido4", "extendido3","extendido2","extendido1","extendido0","reposo"];

        let current_arm_state_index=0;

        const animateArm=(end_callback)=>{
            
            setTimeout(
                ()=>{
                    setRobotArmState(arm_sequence[current_arm_state_index]);
                    current_arm_state_index++;
                    if(current_arm_state_index>arm_sequence.length){
                        current_arm_state_index=0;
                        end_callback();
                    } else {
                        animateArm(end_callback);
                    }
                }
            ,500)
        }

        function finish(){console.log("end");}
        animateArm(finish);
    }  
  // \PICK

    // PICKRAW
    const pickRaw=(garra, bruto, pos,end_callback)=>{
        const doPickRaw = () => {
            const arm_sequence=["reposo","extendido0","extendido1","extendido2","extendido3", "extendido4", "extendido5", "extendido4", "extendido3","extendido2","extendido1","extendido0","reposo"];

            console.log(" * Picking RAW: ", garra,bruto,pos);
            addToSystemLog(" * Picking RAW. Garra: "+ garra+ " Bruto: " + bruto + " Position: " + pos);
            let current_arm_state_index=0;

            const animateArm=(end_callback)=>{

                setTimeout(
                    ()=>{
                        setRobotArmState(arm_sequence[current_arm_state_index]);
                        current_arm_state_index++;
                        if(current_arm_state_index>arm_sequence.length){
                            current_arm_state_index=0;

                            // Use entity objects
                            const { robot, almacen } = useStore.getState();

                            // Check capacity first
                            if (!robot.hasCapacity()) {
                                const errorMsg = ErrorMessages.robotCapacityFull(robot.contains.length, robot.maxCapacity, `${bruto}${pos}`);
                                addToErrorLog(errorMsg);
                            } else {
                                const success = robot.pickRaw(almacen, bruto, pos);
                                if (!success) {
                                    const { ikasmak } = useStore.getState();
                                    const foundLocation = ErrorMessages.findItemInOtherLocations(`${bruto}${pos}`, 'almacen', robot, almacen, ikasmak);
                                    const errorMsg = ErrorMessages.rawNotFoundInAlmacen(`${bruto}${pos}`, foundLocation);
                                    addToErrorLog(errorMsg);
                                }
                            }

                            syncUIState();

                            end_callback();
                        } else {
                            animateArm(end_callback);
                        }
                    }
                ,500)
            }

            animateArm(end_callback);
        };

        // Check if almacen needs to be opened - USE REF FOR SYNC CHECK
        if (!openDrawerRef.current) {
            addToSystemLog(" * Almacen is closed, opening it first");
            openShelves(() => {
                doPickRaw();
            });
            return;
        }

        doPickRaw();
    }  
  // \PICK

    // PICKTOOL
    const pickTool=(herramienta, pos,end_callback)=>{
        const doPickTool = () => {
            const arm_sequence=["reposo","extendido0","extendido1","extendido2","extendido3", "extendido4", "extendido5", "extendido4", "extendido3","extendido2","extendido1","extendido0","reposo"];

            console.log(" * Picking TOOL: ", herramienta,pos);
            addToSystemLog(" * Picking Tool. Herramienta: "+ herramienta+  " Position: " + pos);

            let current_arm_state_index=0;

            const animateArm=(end_callback)=>{

                setTimeout(
                    ()=>{
                        setRobotArmState(arm_sequence[current_arm_state_index]);
                        current_arm_state_index++;
                        if(current_arm_state_index>arm_sequence.length){
                            current_arm_state_index=0;

                            // Use entity objects
                            const { robot, almacen } = useStore.getState();

                            // Check capacity first
                            if (!robot.hasCapacity()) {
                                const errorMsg = ErrorMessages.robotCapacityFull(robot.contains.length, robot.maxCapacity, `${herramienta}${pos}`);
                                addToErrorLog(errorMsg);
                            } else {
                                const success = robot.pickTool(almacen, herramienta, pos);
                                if (!success) {
                                    const { ikasmak } = useStore.getState();
                                    const foundLocation = ErrorMessages.findItemInOtherLocations(`${herramienta}${pos}`, 'almacen', robot, almacen, ikasmak);
                                    const errorMsg = ErrorMessages.toolNotFoundInAlmacen(`${herramienta}${pos}`, foundLocation);
                                    addToErrorLog(errorMsg);
                                }
                            }

                            syncUIState();

                            end_callback();
                        } else {
                            animateArm(end_callback);
                        }
                    }
                ,500)
            }

            animateArm(end_callback);
        };

        // Check if almacen needs to be opened - USE REF FOR SYNC CHECK
        if (!openDrawerRef.current) {
            addToSystemLog(" * Almacen is closed, opening it first");
            openShelves(() => {
                doPickTool();
            });
            return;
        }

        doPickTool();
    }  
  // \PICK  

    // OpenShelves
    const openShelves=(end_callback)=>{
        console.log(" * Open shelves");
        addToSystemLog(" * Open shelves");

        // Check if already open and return early - USE REF
        if(openDrawerRef.current){
            const errorMsg = ErrorMessages.almacenAlreadyOpen();
            addToErrorLog(errorMsg);
            end_callback();
            return;
        }

        const tasks=(end_callback)=>{

            setTimeout(
                ()=>{
                    openDrawerRef.current = true;  // UPDATE REF SYNC
                    setOpenDrawer(true);
                    // Use entity object
                    const { almacen } = useStore.getState();
                    almacen.open();
                    syncUIState();

                    end_callback();
                }
            ,1000)
        }

        tasks(end_callback);
    }
  // \CloseShelves
    // CloseShelves
    const closeShelves=(end_callback)=>{
        console.log(" * Closing shelves");
        addToSystemLog(" * Closing shelves");

        // Check if already closed and return early - USE REF
        if(!openDrawerRef.current){
            const errorMsg = ErrorMessages.almacenAlreadyClosed();
            addToErrorLog(errorMsg);
            end_callback();
            return;
        }
        const tasks=(end_callback)=>{

            setTimeout(
                ()=>{
                    openDrawerRef.current = false;  // UPDATE REF SYNC
                    setOpenDrawer(false);
                    // Use entity object
                    const { almacen } = useStore.getState();
                    almacen.close();
                    syncUIState();

                    end_callback();
                }
            ,1000)
        }

        tasks(end_callback);
    }
  // \CloseShelves
    // PlaceInIkasmak
    const placeRawIkasmak=(garra,bruto,end_callback)=>{
        const doPlaceRawIkasmak = () => {
            const arm_sequence=["reposo","extendido0","extendido1","extendido2","extendido3", "extendido4", "extendido5", "extendido4", "extendido3","extendido2","extendido1","extendido0","reposo"];

            console.log("* Placing in Ikasmak");
            addToSystemLog(" * Placing in Ikasmak. Garra: "+ garra+ " Bruto: " + bruto );

            let current_arm_state_index=0;

            const animateArm=(end_callback)=>{

                setTimeout(
                    ()=>{
                        setRobotArmState(arm_sequence[current_arm_state_index]);
                        current_arm_state_index++;
                        if(current_arm_state_index>arm_sequence.length){
                            current_arm_state_index=0;

                            // Use entity objects
                            const { robot, ikasmak, almacen } = useStore.getState();

                            const robotHasRaw = robot.contains.some(item => item.includes(bruto));

                            if (!robotHasRaw) {
                                const foundLocation = ErrorMessages.findItemInOtherLocations(bruto, 'robot', robot, almacen, ikasmak);
                                const errorMsg = ErrorMessages.rawNotFoundInRobot(foundLocation);
                                addToErrorLog(errorMsg);
                            } else {
                                const success = robot.placeRawIkasmak(ikasmak, bruto);
                                if (!success) {
                                    const errorMsg = ErrorMessages.ikasmakRawCapacityFull(bruto, ikasmak.countItemsByType('raw'), ikasmak.maxRawSlots);
                                    addToErrorLog(errorMsg);
                                }
                            }

                            syncUIState();

                            end_callback();
                        } else {
                            animateArm(end_callback);
                        }
                    }
                ,500)
            }

            animateArm(end_callback);
        };

        // Check if Ikasmak door needs to be opened - USE REF FOR SYNC CHECK
        if (!openMachineDoorRef.current) {
            addToSystemLog(" * Ikasmak door is closed, opening it first");
            openIkasmakDoor(() => {
                doPlaceRawIkasmak();
            });
            return;
        }

        doPlaceRawIkasmak();
    }
  // \PlaceInIkasmak
    // pickupRawIkasmak
    const pickupRawIkasmak=(bruto, garra,end_callback)=>{
        const doPickupRawIkasmak = () => {
            const arm_sequence=["reposo","extendido0","extendido1","extendido2","extendido3", "extendido4", "extendido5", "extendido4", "extendido3","extendido2","extendido1","extendido0","reposo"];

            console.log(" * Pickup from Ikasmak", garra);
            addToSystemLog(" * Pickup from Ikasmak. Garra: "+ garra );

            let current_arm_state_index=0;

            const animateArm=(end_callback)=>{

                setTimeout(
                    ()=>{
                        setRobotArmState(arm_sequence[current_arm_state_index]);
                        current_arm_state_index++;
                        if(current_arm_state_index>arm_sequence.length){

                            // Use entity objects
                            const { robot, ikasmak } = useStore.getState();

                            // Check capacity first
                            if (!robot.hasCapacity()) {
                                const errorMsg = ErrorMessages.robotCapacityFull(robot.contains.length, robot.maxCapacity, "pieza");
                                addToErrorLog(errorMsg);
                            } else {
                                const success = robot.pickUpRawIkasmak(ikasmak);

                                if (!success) {
                                    const errorMsg = ErrorMessages.pieceNotFoundInIkasmak();
                                    addToErrorLog(errorMsg);
                                }
                            }

                            syncUIState();

                            current_arm_state_index=0;
                            end_callback();
                        } else {
                            animateArm(end_callback);
                        }
                    }
                ,500)
            }

            animateArm(end_callback);
        };

        // Check if Ikasmak door needs to be opened - USE REF FOR SYNC CHECK
        if (!openMachineDoorRef.current) {
            addToSystemLog(" * Ikasmak door is closed, opening it first");
            openIkasmakDoor(() => {
                doPickupRawIkasmak();
            });
            return;
        }

        doPickupRawIkasmak();
    }  
  // \pickupRawIkasmak      

    // PlaceToolInIkasmak
    const placeToolIkasmak=(garra,herramienta,end_callback)=>{
        const doPlaceToolIkasmak = () => {
            const arm_sequence=["reposo","extendido0","extendido1","extendido2","extendido3", "extendido4", "extendido5", "extendido4", "extendido3","extendido2","extendido1","extendido0","reposo"];

            console.log("* Placing in Ikasmak");
            addToSystemLog(" * Placing TOOL in Ikasmak. Herramienta: "+ herramienta+ " garra: " + garra );

            let current_arm_state_index=0;

            const animateArm=(end_callback)=>{

                setTimeout(
                    ()=>{
                        setRobotArmState(arm_sequence[current_arm_state_index]);
                        current_arm_state_index++;
                        if(current_arm_state_index>arm_sequence.length){
                            current_arm_state_index=0;

                            // Use entity objects
                            const { robot, ikasmak, almacen } = useStore.getState();

                            const robotHasTool = robot.contains.some(item => item.includes(herramienta));

                            if (!robotHasTool) {
                                const foundLocation = ErrorMessages.findItemInOtherLocations(herramienta, 'robot', robot, almacen, ikasmak);
                                const errorMsg = ErrorMessages.toolNotFoundInRobotForIkasmak(herramienta, foundLocation);
                                addToErrorLog(errorMsg);
                            } else {
                                const success = robot.placeToolIkasmak(ikasmak, herramienta);
                                if (!success) {
                                    const errorMsg = ErrorMessages.ikasmakToolCapacityFull(herramienta, ikasmak.countItemsByType('tool'), ikasmak.maxToolSlots);
                                    addToErrorLog(errorMsg);
                                }
                            }

                            syncUIState();

                            end_callback();
                        } else {
                            animateArm(end_callback);
                        }
                    }
                ,500)
            }

            animateArm(end_callback);
        };

        // Check if Ikasmak door needs to be opened - USE REF FOR SYNC CHECK
        if (!openMachineDoorRef.current) {
            addToSystemLog(" * Ikasmak door is closed, opening it first");
            openIkasmakDoor(() => {
                doPlaceToolIkasmak();
            });
            return;
        }

        doPlaceToolIkasmak();
    }  
  // \PlaceToolInIkasmak      
    // pickupToolIkasmak
    const pickupToolIkasmak=(bruto, herramienta,end_callback)=>{
        const doPickupToolIkasmak = () => {
            const arm_sequence=["reposo","extendido0","extendido1","extendido2","extendido3", "extendido4", "extendido5", "extendido4", "extendido3","extendido2","extendido1","extendido0","reposo"];

            console.log(" * Pickup tool from Ikasmak", herramienta);
            addToSystemLog(" * Pickup tool from Ikasmak. Herramienta: "+ herramienta );

            let current_arm_state_index=0;

            const animateArm=(end_callback)=>{

                setTimeout(
                    ()=>{
                        setRobotArmState(arm_sequence[current_arm_state_index]);
                        current_arm_state_index++;
                        if(current_arm_state_index>arm_sequence.length){

                            // Use entity objects
                            const { robot, ikasmak } = useStore.getState();

                            // Check capacity first
                            if (!robot.hasCapacity()) {
                                const errorMsg = ErrorMessages.robotCapacityFull(robot.contains.length, robot.maxCapacity, herramienta);
                                addToErrorLog(errorMsg);
                            } else {
                                const success = robot.pickUpToolIkasmak(ikasmak, herramienta);
                                if (!success) {
                                    const { almacen } = useStore.getState();
                                    const foundLocation = ErrorMessages.findItemInOtherLocations(herramienta, 'ikasmak', robot, almacen, ikasmak);
                                    const errorMsg = ErrorMessages.toolNotFoundInIkasmak(herramienta, foundLocation);
                                    addToErrorLog(errorMsg);
                                }
                            }

                            syncUIState();

                            current_arm_state_index=0;
                            end_callback();
                        } else {
                            animateArm(end_callback);
                        }
                    }
                ,500)
            }

            animateArm(end_callback);
        };

        // Check if Ikasmak door needs to be opened - USE REF FOR SYNC CHECK
        if (!openMachineDoorRef.current) {
            addToSystemLog(" * Ikasmak door is closed, opening it first");
            openIkasmakDoor(() => {
                doPickupToolIkasmak();
            });
            return;
        }

        doPickupToolIkasmak();
    }  
  // \pickupToolIkasmak      
    // openIkasmakDoor
    const openIkasmakDoor=(end_callback)=>{

        console.log(" * Open Ikasmak");
        addToSystemLog(" * Open Ikasmak");

        // Check if already open and return early - USE REF (silently skip if already open)
        if(openMachineDoorRef.current){
            // Already open, just continue without error
            end_callback();
            return;
        }


        const tasks=(end_callback)=>{

            setTimeout(
                ()=>{
                    openMachineDoorRef.current = true;  // UPDATE REF SYNC
                    setOpenMachineDoor(true);
                    // Use entity object
                    const { ikasmak } = useStore.getState();
                    ikasmak.open();
                    syncUIState();

                    end_callback();
                }
            ,1000)
        }

        tasks(end_callback);
    }
  // \openIkasmakDoor
      // closeIkasmakDoor
    const closeIkasmakDoor=(end_callback)=>{

        console.log(" * Close Ikasmak");
        addToSystemLog(" * Close Ikasmak");

        // Check if already closed and return early - USE REF
        if(!openMachineDoorRef.current){
            const errorMsg = ErrorMessages.ikasmakAlreadyClosed();
            addToErrorLog(errorMsg);
            end_callback();
            return;
        }

        const tasks=(end_callback)=>{

            setTimeout(
                ()=>{
                    openMachineDoorRef.current = false;  // UPDATE REF SYNC
                    setOpenMachineDoor(false);
                    // Use entity object
                    const { ikasmak } = useStore.getState();
                    ikasmak.close();
                    syncUIState();

                    end_callback();
                }
            ,1000)
        }

        tasks(end_callback);
    }
  // \closeIkasmakDoor  
  // machineRaw
      const machineRaw=(tool, prog, pieceId, end_callback)=>{

        console.log(" * Machining RAW", tool, prog, pieceId);
        addToSystemLog(" * Machining RAW. Tool: "+tool+ " Prog:"+prog+ " PieceID:"+pieceId);

        const tasks=(end_callback)=>{

            setTimeout(
                ()=>{
                    // Robot performs machining (not Ikasmak)
                    // Tool(s) stay in Ikasmak, only raw disappears, piece is created
                    const { robot, ikasmak } = useStore.getState();

                    if (robot.getLocation() !== "ikasmak") {
                        const errorMsg = ErrorMessages.robotNotAtIkasmakForMachining(robot.getLocation());
                        addToErrorLog(errorMsg);
                    } else {
                        // Parse tools: can be single or comma-separated (max 2)
                        const toolsArray = tool.split(',').map(t => t.trim()).filter(t => t.length > 0);

                        // Validate all tools exist in Ikasmak
                        let allToolsExist = true;
                        for (const singleTool of toolsArray) {
                            const toolExists = ikasmak.contains.some(item => item.includes(singleTool));
                            if (!toolExists) {
                                const errorMsg = ErrorMessages.toolNotAvailableForMachining(singleTool);
                                addToErrorLog(errorMsg);
                                allToolsExist = false;
                                break;
                            }
                        }

                        if (allToolsExist) {
                            const success = robot.machineRaw(ikasmak, tool, prog, pieceId || "piece");
                            if (!success) {
                                const errorMsg = ErrorMessages.rawNotAvailableForFirstMachining();
                                addToErrorLog(errorMsg);
                            }
                        }
                    }

                    syncUIState();

                    end_callback();
                }
            ,3000)
        }

        tasks(end_callback);
    }
  // \machineRaw  
  // PlacePiece
      const placePiece=(pieza, bruto, posicion, originalPieza, end_callback)=>{
        const doPlacePiece = () => {
            const arm_sequence=["reposo","extendido0","extendido1","extendido2","extendido3", "extendido4", "extendido5", "extendido4", "extendido3","extendido2","extendido1","extendido0","reposo"];
            console.log(" * Placing piece: ", pieza, bruto, posicion);
            addToSystemLog(" * Placing piece. Pieza: "+(originalPieza || pieza) + " Bruto:"+bruto+ " Posicion: " + posicion);

            let current_arm_state_index=0;

            const animateArm=(end_callback)=>{

                setTimeout(
                    ()=>{
                        setRobotArmState(arm_sequence[current_arm_state_index]);
                        current_arm_state_index++;
                        if(current_arm_state_index>arm_sequence.length){
                            // Use entity objects
                            const { robot, almacen, ikasmak } = useStore.getState();

                            const robotHasPiece = robot.contains.some(item => item.includes(pieza));
                            const inIkasmak = ikasmak.currentPiece && ikasmak.currentPiece.includes(pieza);

                            if (!robotHasPiece) {
                                const errorMsg = ErrorMessages.pieceNotFoundInRobotForAlmacen(originalPieza || pieza, inIkasmak);
                                addToErrorLog(errorMsg);
                            } else {
                                const success = robot.placePiece(almacen, pieza);
                                if (!success) {
                                    const errorMsg = ErrorMessages.almacenClosedForPlace(originalPieza || pieza);
                                    addToErrorLog(errorMsg);
                                }
                            }

                            syncUIState();

                            current_arm_state_index=0;
                            end_callback();
                        } else {
                            animateArm(end_callback);
                        }
                    }
                ,500)
            }

            animateArm(end_callback);
        };

        // Check if almacen needs to be opened - USE REF FOR SYNC CHECK
        if (!openDrawerRef.current) {
            addToSystemLog(" * Almacen is closed, opening it first");
            openShelves(() => {
                doPlacePiece();
            });
            return;
        }

        doPlacePiece();
    }
  // \PlacePiece
  // PlaceTool
      const placeTool=(herramienta, bruto, posicion, end_callback)=>{
        const doPlaceTool = () => {
            const arm_sequence=["reposo","extendido0","extendido1","extendido2","extendido3", "extendido4", "extendido5", "extendido4", "extendido3","extendido2","extendido1","extendido0","reposo"];

            console.log(" * Placing tool: ", herramienta, bruto, posicion);
            addToSystemLog(" * Placing tool. Herramienta: "+herramienta + " Bruto:"+bruto+ " Posicion: " + posicion);
            let current_arm_state_index=0;

            const animateArm=(end_callback)=>{

                setTimeout(
                    ()=>{
                        setRobotArmState(arm_sequence[current_arm_state_index]);
                        current_arm_state_index++;
                        if(current_arm_state_index>arm_sequence.length){
                            // Use entity objects
                            const { robot, almacen, ikasmak } = useStore.getState();

                            const robotHasTool = robot.contains.some(item => item.includes(herramienta));

                            if (!robotHasTool) {
                                const foundLocation = ErrorMessages.findItemInOtherLocations(herramienta, 'robot', robot, almacen, ikasmak);
                                const errorMsg = ErrorMessages.toolNotFoundInRobotForAlmacen(herramienta, foundLocation);
                                addToErrorLog(errorMsg);
                            } else {
                                const success = robot.placeTool(almacen, herramienta);
                                if (!success) {
                                    const errorMsg = ErrorMessages.almacenClosedForPlace(herramienta);
                                    addToErrorLog(errorMsg);
                                }
                            }

                            syncUIState();

                            current_arm_state_index=0;
                            end_callback();
                        } else {
                            animateArm(end_callback);
                        }
                    }
                ,500)
            }

            animateArm(end_callback);
        };

        // Check if almacen needs to be opened - USE REF FOR SYNC CHECK
        if (!openDrawerRef.current) {
            addToSystemLog(" * Almacen is closed, opening it first");
            openShelves(() => {
                doPlaceTool();
            });
            return;
        }

        doPlaceTool();
    }  
  // \PlaceTool  
  // ChargeBattery
      const chargeBattery=(end_callback)=>{
        const doChargeBattery = () => {
            console.log(" * Charging Battery");
            addToSystemLog(" * Charging battery at cargador");

            // Charging takes time but no arm movement, just robot at cargador
            setTimeout(() => {
                // Battery charged
                console.log(" * Battery charged");
                addToSystemLog(" * Battery charged");
                end_callback();
            }, 2000);
        };

        // Check if robot needs to move to cargador - Get fresh location
        const { robot } = useStore.getState();
        const currentLocation = robot.getLocation();

        if (currentLocation !== "cargador") {
            addToSystemLog(" * Robot not at cargador, moving there first");
            moveRobot("cargador", () => {
                doChargeBattery();
            });
            return;
        }

        doChargeBattery();
    }  
  // \ChargeBattery  
    // Notify
      const notify=(what, end_callback)=>{

        console.log(" * Notify", what);
        addToSystemLog(" * Notify: '" + what + "'");

        // Use entity object
        const { notifications: notificationSystem } = useStore.getState();
        notificationSystem.notify(what);
        syncUIState();

        const tasks=(end_callback)=>{

            setTimeout(
                ()=>{
                    end_callback();
                }
            ,500)
        }

        tasks(end_callback);
    }  
  // \Notify  
      // Measure
      const measure=(pieza, originalPieza, end_callback)=>{
        const doMeasure = () => {
            console.log(" * Measure", pieza);
            addToSystemLog(" * Measure: '" + (originalPieza || pieza) + "'");

            const tasks=(end_callback)=>{

                setTimeout(
                    ()=>{
                        // Use entity objects - Get fresh location from robot
                        const { robot, medicion } = useStore.getState();
                        const currentLocation = robot.getLocation();
                        const success = robot.measure(medicion, pieza, currentLocation);

                        if (!success) {
                            const errorMsg = ErrorMessages.pieceNotFoundForMeasure(originalPieza || pieza);
                            addToErrorLog(errorMsg);
                        }

                        syncUIState();

                        end_callback();
                    }
                ,2500)
            }

            tasks(end_callback);
        };

        // Check if robot needs to move to metrologia - Get fresh location
        const { robot } = useStore.getState();
        const currentLocation = robot.getLocation();

        if (currentLocation !== "metrologia") {
            addToSystemLog(" * Robot not at metrologia, moving there first");
            moveRobot("metrologia", () => {
                doMeasure();
            });
            return;
        }

        doMeasure();
    }
  // \Notify


  return (
    <AppShell
      header={{ height: 60 }}
      navbar={{
        width: 380,
        breakpoint: 'sm',        
      }}
      padding="md"
    >
      <AppShell.Header>
        <Burger
          opened={opened}
          onClick={()=>{setOpened(!opened)}}
          hiddenFrom="sm"
          size="sm"
        />
        <div>
            <div style={{float:"left"}}><img src="https://www.tecnalia.com/images/logo.svg" alt="Tecnalia Logo" height={50} style={{margin: "5px"}}/></div>
            <div style={{float:"left", marginLeft: "50%", marginTop: "-5px"}}><h3>IKASPROD</h3></div>
        </div>
      </AppShell.Header>

      <AppShell.Navbar p="md">

        <Tabs defaultValue="BehaviorTree" value={selectedTab} onChange={(e)=>{
            setSelectedTab(e);
        }}>
        <Tabs.List>
            <Tabs.Tab value="BehaviorTree" leftSection={<IconSettings size={12} />}>        
            </Tabs.Tab>
            <Tabs.Tab value="messages" leftSection={<IconMessageCircle size={12} />}>
                Log
            </Tabs.Tab>

            <Tabs.Tab value="sistemas" leftSection={<IconMessageCircle size={12} />}>
                Sistemas
            </Tabs.Tab>            

            <Tabs.Tab value="errores" leftSection={<IconMessageCircle size={12} />}>
                Errores
            </Tabs.Tab>   

        </Tabs.List>

        <Tabs.Panel value="BehaviorTree">

        { (executingMission && xmlLoaded ) &&
            <>... reload to restart ...</>
        }

        { (!executingMission && !xmlLoaded ) &&
                            <Dropzone
                                accept={[MIME_TYPES.text]}
                                onDrop={async (files) => {
                                    console.log('accepted files', files);
                                    const f=files[0];


                                    var reader = new FileReader();
                                    reader.onerror = function(e) {
                                        console.log(e);
                                    }

                                    reader.onload = function() {
                                    var text = reader.result;
                                    const regex = /#.+/gm; // Quitar comentarios...
                                    
                                    
                                    text=text.replace(regex,"");
                                    console.log(text);

                                    let temp;
                                    
                                    try {
                                        temp=JSON.parse(convert.xml2json(text));
                                    } catch(error){
                                        console.log(error);
                                        alert("XML is not valid."+error);
                                        return;
                                    }
                                    console.log(temp);

                                    console.log("================");

                                    clearSystemLog();
                                    resetErrorSession();

                                    console.log(temp.elements[0].elements);
                                    let parsedActions=[];

                                    const extractActions = (elements) => {
                                        elements.map((item) => {
                                            if(item.name==="Action"){
                                                let action=item.attributes;
                                                action.name="Action";
                                                parsedActions.push(action);
                                            } else if(item.name==="Sequence" && item.elements) {
                                                extractActions(item.elements);
                                            }
                                            return null; // Added return for map callback
                                        });
                                    };

                                    extractActions(temp.elements[0].elements);

                                    console.log(parsedActions);

                                    // Extract unique raws and tools from BT and populate Almacén
                                    const uniqueRaws = new Set();
                                    const uniqueTools = new Set();
                                    const knownRawNames = new Set(); // For validation (no position)
                                    const knownToolNames = new Set(); // For validation (no position)

                                    parsedActions.forEach(action => {
                                        // Extract raws and tools from ALL actions (case-insensitive)
                                        Object.keys(action).forEach(key => {
                                            if (key.toLowerCase() === 'bruto' && action[key]) {
                                                const rawName = action[key];
                                                knownRawNames.add(rawName);

                                                // If this is a PickUpRaw action, also add to Almacén with position
                                                if (action.ID === "PickUpRaw") {
                                                    const position = action.Pos || "";
                                                    uniqueRaws.add(rawName + position);
                                                }
                                            }
                                            if (key.toLowerCase() === 'herramienta' && action[key]) {
                                                const toolName = action[key];
                                                knownToolNames.add(toolName);

                                                // If this is a PickUpTool action, also add to Almacén with position
                                                if (action.ID === "PickUpTool") {
                                                    const position = action.Pos || "";
                                                    uniqueTools.add(toolName + position);
                                                }
                                            }
                                        });
                                    });

                                    // Get entities and populate
                                    const { almacen, ikasmak } = useStore.getState();

                                    // Reset Almacén first
                                    almacen.reset();

                                    // Add all unique raws
                                    uniqueRaws.forEach(raw => {
                                        almacen.addItem(raw);
                                    });

                                    // Add all unique tools
                                    uniqueTools.forEach(tool => {
                                        almacen.addItem(tool);
                                    });

                                    // Set known items in Ikasmak for validation
                                    ikasmak.setKnownItems(knownRawNames, knownToolNames);

                                    // Sync UI state
                                    syncUIState();

                                    console.log("Almacén initialized with:");
                                    console.log("- Raws:", Array.from(uniqueRaws));
                                    console.log("- Tools:", Array.from(uniqueTools));
                                    console.log("- Total items:", almacen.getState().contains.length);
                                    console.log("Known raw names for validation:", Array.from(knownRawNames));
                                    console.log("Known tool names for validation:", Array.from(knownToolNames));

                                    jsonMision=parsedActions;
                                    setXMLLoaded(true);
                                    
                                    
                                    };
                                    reader.readAsText(f);
                                }}
                                >
                                    <Group justify="center" gap="xl" mih={220} style={{ pointerEvents: 'none' }}>
                                    <Dropzone.Accept>
                                    <IconUpload size={52} color="var(--mantine-color-blue-6)" stroke={1.5} />
                                    </Dropzone.Accept>
                                    <Dropzone.Reject>
                                    <IconX size={52} color="var(--mantine-color-red-6)" stroke={1.5} />
                                    </Dropzone.Reject>
                                    <Dropzone.Idle>
                                    <IconPhoto size={52} color="var(--mantine-color-dimmed)" stroke={1.5} />
                                    </Dropzone.Idle>
                        
                                    <div>
                                    <Text size="xl" inline>
                                        Arrastra aquí el BT (XML)
                                    </Text>

                                    </div>
                                </Group>
                                </Dropzone>            
                }

                { false &&
                    <>
                    <button onClick={()=>{


                        pick();

                        }}>Animate</button>
                
                        <hr/>
                        <button onClick={()=>{
                                moveRobot(location);

                                }}>Move To</button>

                        <Select data={["almacen", "frente_almacen", "frente_maquina", "maquina", "frente_metrologia", "metrologia", "cargador"]} 
                            value={location} onChange={setLocation} />

                        <Select data={["reposo", "extendido0", "extendido1", "extendido2", "extendido3", "extendido4", "extendido5"]} 
                            value={armState} onChange={setArmState} />                              
                    </>
                }
  
                { (!executingMission && xmlLoaded)  &&
                    <>
                        <br/>
                          <Button w={"100%"} onClick={()=>{
                                // let end_callback; // Unused but kept for future use


                                setExecutingMission(true);

                                let MISION=[
                                //{"step": (next_step_callback)=>{moveRobot("metrologia", next_step_callback)}},
                                //{"step": (next_step_callback)=>{pick(next_step_callback)}},
                                ]
                                //jsonMision=[];

                                const normalize = (str) => {
                                    if(!str) return "";
                                    return str.toLowerCase()
                                        .normalize("NFD")
                                        .replace(/[\u0300-\u036f]/g, "")
                                        .trim();
                                };

                                jsonMision.map((step,index)=>{
                                    if(step.ID==="MoveCharlieTo"){
                                        const destination = normalize(step.Pos);
                                        MISION.push( {"step": (next_step_callback)=>{moveRobot(destination, next_step_callback)} , "info": step }  );
                                    } 
                                    else if(step.ID==="PickUpRaw"){

                                        //MISION.push( {"step": (next_step_callback)=>{openShelves(next_step_callback)}, "info": step }  );
                                        MISION.push( {"step": (next_step_callback)=>{pickRaw(step.Garra, step.Bruto, step.Pos, next_step_callback)}, "info": step }  );
                                    }                          
                                    else if(step.ID==="PickUpTool"){
                                        //MISION.push( {"step": (next_step_callback)=>{openShelves(next_step_callback)}, "info": step }  );
                                        MISION.push( {"step": (next_step_callback)=>{pickTool(step.Herramienta, step.Pos, next_step_callback)} , "info": step}  );
                                    }     
                                    else if(step.ID==="OpenShelfs"){
                                        MISION.push( {"step": (next_step_callback)=>{openShelves(next_step_callback)} , "info": step}  );
                                    }                                           
                                    else if(step.ID==="CloseShelfs"){
                                        MISION.push( {"step": (next_step_callback)=>{closeShelves(next_step_callback)} , "info": step}  );
                                    }                                                                 
                                    else if(step.ID==="PlaceRawIkasmak"){
                                        MISION.push( {"step": (next_step_callback)=>{openIkasmakDoor(next_step_callback)} , "info": step}  );
                                        MISION.push( {"step": (next_step_callback)=>{placeRawIkasmak(step.Garra, step.Bruto, next_step_callback)} , "info": step}  );
                                    } 
                                    else if(step.ID==="PickUpRawIkasmak"){
                                        MISION.push( {"step": (next_step_callback)=>{pickupRawIkasmak(step.Bruto, step.Garra, next_step_callback)} , "info": step}  );
                                    }      
                                    else if(step.ID==="PlaceToolIkasmak"){
                                        MISION.push( {"step": (next_step_callback)=>{openIkasmakDoor(next_step_callback)} , "info": step}  );
                                        MISION.push( {"step": (next_step_callback)=>{placeToolIkasmak(step.Garra, step.Herramienta, next_step_callback)} , "info": step}  );
                                    } 
                                    else if(step.ID==="PickUpToolIkasmak"){
                                        MISION.push( {"step": (next_step_callback)=>{pickupToolIkasmak(step.Bruto, step.Herramienta, next_step_callback)} , "info": step}  );
                                    }                                          
                                    else if(step.ID==="CloseIkasmakDoor"){
                                        MISION.push( {"step": (next_step_callback)=>{closeIkasmakDoor(next_step_callback)} , "info": step}  );
                                    }           
                                    else if(step.ID==="OpenIkasmakDoor"){
                                        MISION.push( {"step": (next_step_callback)=>{openIkasmakDoor(next_step_callback)} , "info": step}  );
                                    }  
                                    else if(step.ID==="Measure"){
                                        // Normalize piece name: remove spaces, lowercase, pieza→piece
                                        const normalizedPieza = step.Pieza ? step.Pieza.toLowerCase().replace(/\s+/g, '').replace(/^pieza/, 'piece') : '';
                                        const originalPieza = step.Pieza;
                                        MISION.push( {"step": (next_step_callback)=>{measure(normalizedPieza, originalPieza, next_step_callback)} , "info": step}  );
                                    }
                                    else if(step.ID==="ChargeBattery"){
                                        MISION.push( {"step": (next_step_callback)=>{chargeBattery(next_step_callback)} , "info": step}  );
                                    }
                                    else if(step.ID.startsWith("MachiningRaw")){
                                        // Use step's own ID attribute or generic "piece"
                                        const pieceId = step.Pieza || step.attributes?.ID || "piece";
                                        MISION.push( {"step": (next_step_callback)=>{machineRaw(step.Herramienta, step.Prog, pieceId, next_step_callback)} , "info": step}  );
                                    }        
                                    else if(step.ID==="PlacePiece"){
                                        // Normalize piece name: remove spaces, lowercase, pieza→piece
                                        const normalizedPieza = step.Pieza ? step.Pieza.toLowerCase().replace(/\s+/g, '').replace(/^pieza/, 'piece') : '';
                                        const originalPieza = step.Pieza;
                                        MISION.push( {"step": (next_step_callback)=>{placePiece(normalizedPieza, step.Bruto,step.Pos, originalPieza, next_step_callback)} , "info": step}  );
                                    }  
                                    else if(step.ID==="PlaceTool"){
                                        MISION.push( {"step": (next_step_callback)=>{placeTool(step.Herramienta, step.Bruto,step.Pos, next_step_callback)} , "info": step}  );
                                    }         
                                    else if(step.ID==="ChargeBattery"){
                                        //MISION.push( {"step": (next_step_callback)=>{moveRobot("cargador", next_step_callback)} , "info": "Going to charge" }  );
                                        MISION.push( {"step": (next_step_callback)=>{chargeBattery(next_step_callback)} , "info": step}  );
                                    }                            
                                    else if(step.ID==="Notify"){
                                        MISION.push( {"step": (next_step_callback)=>{notify(step.Estado, next_step_callback)} , "info": step}  );
                                    }
                                    return null; // Added return for map callback
                                });
                                
                                
                                

                                const executeMision=(steps)=>{
                                    const this_step=steps.shift();
                                    const callback=(steps)=>{executeMision(steps)}

                                    if(this_step){
                                        this_step["step"](  ()=>{callback(steps)} );
                                    }
                                }
                                console.log(MISION);

                                setSelectedTab("messages");

                                executeMision(MISION);

                                }}>LAUNCH MISION
                        </Button>  
                        
                    </>
                }

        </Tabs.Panel>

        <Tabs.Panel value="messages">
            System status

            <br/>
            
            <div style={{height: "400px", overflow: "auto"}}>
                <small dangerouslySetInnerHTML={{__html: systemLog}} ></small>
            </div>


        </Tabs.Panel>

        <Tabs.Panel value="sistemas">
            <br/>

            <div>
                Almacén:<br/>
                 · {almacen?.getState().opened || "cerrado"}
                 <br/>
                 { almacen?.getState().contains?.length > 0 &&
                    <>
                        · Contiene: <small style={{fontSize: "80%"}}>{
                            almacen.getState().contains.join(", ")
                        }</small>
                    </>
                 }
                 <br/>

            </div>

            <hr/>

            <div>
                Robot:<br/>
                 · Ubicación: {robot?.getLocation() || "desconocida"}
                 <br/>
                 · Estado brazo: {robot?.getArmState() || "reposo"}
                 <br/>
                 { robot?.getState().contains?.length > 0 &&
                    <>
                        · Contiene: <small style={{fontSize: "80%"}}>{
                            robot.getState().contains.join(", ")
                        }</small>
                        <br/>
                    </>
                  }
            </div>
            <hr/>
            <div>
                Ikasmak:<br/>
                 · {ikasmak?.getState().opened || "cerrado"}
                 <br/>
                 { ikasmak?.getState().contains?.length > 0 &&
                    <>
                        · Contiene: <small style={{fontSize: "80%"}}>{
                            ikasmak.getState().contains.join(", ")
                        }</small>
                        <br/>
                    </>
                }
                 { ikasmak?.getState().currentPiece &&
                    <>
                        · Pieza mecanizada: <small style={{fontSize: "80%"}}>{
                            ikasmak.getState().currentPiece
                        }</small>
                        <br/>
                    </>
                }
                 { robot?.getState().consumedRaws?.length > 0 &&
                    <>
                        · Brutos gastados: <small style={{fontSize: "80%"}}>{
                            robot.getState().consumedRaws.join(", ")
                        }</small>
                    </>
                  }
                 <br/>

            </div>

            <hr/>

            <div>
                Medición:<br/>
                { medicion && Object.keys(medicion.getState()).length > 0 ? (
                    Object.entries(medicion.getState()).map(([pieza, count]) => (
                        <div key={pieza}>
                            · {pieza}: {count} mediciones
                        </div>
                    ))
                ) : (
                    <small style={{color: "#888"}}>Sin mediciones</small>
                )}
                <br/>
            </div>

            <hr/>

            <div>
                Notificaciones:<br/>
                { notificationSystem && notificationSystem.getState()?.length > 0 ? (
                    notificationSystem.getState().map((notif, index) => (
                        <div key={index}>
                            · {notif}
                        </div>
                    ))
                ) : (
                    <small style={{color: "#888"}}>Sin notificaciones</small>
                )}
                <br/>
            </div>

        </Tabs.Panel>

         <Tabs.Panel value="errores">
            <br/>
            <small dangerouslySetInnerHTML={{__html: errorLog}} ></small>            
         </Tabs.Panel>

        </Tabs>

        





      </AppShell.Navbar>

      <AppShell.Main>{props.children}</AppShell.Main>
    </AppShell>
  );
}
